module.exports = __webpack_public_path__ + "img/2022_NC2.6bb187c8.jpg";